import { render } from "./LocationIcon.vue?vue&type=template&id=589d3b58&scoped=true"
const script = {}

import "./LocationIcon.vue?vue&type=style&index=0&id=589d3b58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589d3b58"]])

export default __exports__